import styled from "styled-components";

export const ContainerOptionsLabel = styled.div`
  align-items: center;
  gap: 0.5rem;
  display: flex;

  p {
    font: 500 0.875rem "inter";
    color: ${({ theme }) => theme.console.inputColor};
    margin: 0;
  }

  @font-face {
    font-family: NotoColorEmojiLimited;
    unicode-range: U+1F1E6-1F1FF;
    src: url(https://raw.githack.com/googlefonts/noto-emoji/main/fonts/NotoColorEmoji.ttf);
  }

  span {
    font-family: "NotoColorEmojiLimited", -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol";
  }
`;
